exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.leftpane {\n    background-color: #f8fff8;\n}\n.ontology-small {\n  border-top: 1px solid #c5c5c5;\n  color: #666666;\n  text-align: right;\n  margin: 10px 0 0;\n  padding: 10px;\n  color:#31b34a;\n}\n.ontology-small-title {\n  font-weight: bold;\n  color:#31b34a;\n}\ndiv.top-terms {\n  font-size: 11px;\n  font-weight: bold;\n  line-height: 12px;\n}\ndiv.top-term {\n  display: inline;\n  font-size: 11px;\n  margin: 0 5px;\n  font-weight: normal;\n  font-style: normal;\n  float: none;\n}\n\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-843a8ce8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/OntologiesLeftPane.vue
// module id = 9VbD
// module chunks = 1